var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopPlaylistList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#CCCDD3",
    fillOpacity: 0.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87762 8.04443H3.81089C3.46121 8.04443 3.17773 8.32791 3.17773 8.67759C3.17773 9.02727 3.46121 9.31074 3.81089 9.31074H9.87762C10.2273 9.31074 10.5108 9.02727 10.5108 8.67759C10.5108 8.32791 10.2273 8.04443 9.87762 8.04443Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87762 5.46387H3.81089C3.46121 5.46387 3.17773 5.74734 3.17773 6.09702C3.17773 6.4467 3.46121 6.73017 3.81089 6.73017H9.87762C10.2273 6.73017 10.5108 6.4467 10.5108 6.09702C10.5108 5.74734 10.2273 5.46387 9.87762 5.46387Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70656 10.626H3.81089C3.46121 10.626 3.17773 10.9094 3.17773 11.2591C3.17773 11.6088 3.46121 11.8923 3.81089 11.8923H7.70656C8.05624 11.8923 8.33971 11.6088 8.33971 11.2591C8.33971 10.9094 8.05624 10.626 7.70656 10.626Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0109 5.52065C13.9068 5.45633 13.7756 5.4465 13.6622 5.49438L11.7067 6.3208C11.5743 6.37675 11.489 6.50161 11.489 6.63936V11.0107C11.2731 10.8916 11.0227 10.8231 10.7557 10.8231C9.94698 10.8231 9.28906 11.4487 9.28906 12.2176C9.28906 12.9866 9.94698 13.6122 10.7557 13.6122C11.5644 13.6122 12.2223 12.9866 12.2223 12.2176V8.2605L13.96 7.52612C14.0924 7.47017 14.1778 7.34532 14.1778 7.20753V5.81297C14.1778 5.69497 14.115 5.58494 14.0109 5.52065V5.52065Z",
    fill: "#2D2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPlaylistList);
export default __webpack_public_path__ + "static/media/top_playlist_list.07606868f5500603290dd40fc2168f69.svg";
export { ForwardRef as ReactComponent };